<template>
  <v-row :class="color">
    <v-col cols="12"
           class="align-self-center">
      <v-row>
        <v-col cols="12"
               :class="`text-center main-text ${headerFontSize} ${!subtitle ? 'mb-5' : ''}`"
               style="line-height: 150% !important;">
          <b>
            <span v-html="title"></span>
          </b>
        </v-col>
        <v-col cols="12"
               v-if="subtitle"
               :class="`text-center mb-5 main-text ${subheaderFontSize}`"
               style="line-height: 150% !important;">
          <b>
            <span v-html="subtitle"></span>
          </b>
        </v-col>
        <v-col cols="12"
               md="2"
               offset="0"
               :class="i % 3 === 0 ? 'offset-md-1' : 'offset-md-2'"
               v-for="(item, i) in items"
               :key="`item-${i}`">
          <a v-if="item.href"
             :href="item.href"
             rel="noreferrer"
             target="_blank"
             :aria-label="item.alt">
            <img :class="`img-style ${isMobileView ? 'pa-4' : ''}`"
                 :alt="item.alt ? item.alt : item.text"
                 style="width: 100%;"
                 :src="item.src">
          </a>
          <img v-else
               :class="`img-style ${isMobileView ? 'pa-4' : ''}`"
               style="width: 100%;"
               :alt="item.alt ? item.alt : item.text"
               :src="item.src">
          <p v-if="item.text"
             :class="`text-center main-text ${subheaderFontSize}`">
            <b class="more-space">
              <span v-html="item.text"></span>
            </b>
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import VueOnGeoGlobalMixin from "./vue-ongeo-global-mixin.js";

export default {
  name: "vue-ongeo-image-list",
  mixins: [VueOnGeoGlobalMixin],
  props: {
    title: { type: String, required: true },
    subtitle: String,
    items: { type: Array, required: true },
    color: { type: String, default: "green" }
  }
};
</script>

<style lang="scss">
.img-style {
  border: 10px solid transparent;
}

.more-space {
  line-height: 150% !important;
}
</style>
